(function () {
  var triggers = document.querySelectorAll('.cds-footer__col-trigger');
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      if (window.innerWidth >= 750) return;
      var col = trigger.closest('.cds-footer__col');
      var isOpen = col.classList.contains('is-open');
      col.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
    });
  });
})();
